import { configureStore } from "@reduxjs/toolkit";
import vehicleReducer from "./slices/vehicleSlice";
import faqSlice from "./slices/faqSlice";
import locationSlice from "./slices/locationSlice";
import popupsReducer from "./slices/popupSlice";
import snackbarSliceReducer from "./slices/snackbarSlice";
import leadSlice from "./slices/leadSlice";

export const store = configureStore({
  reducer: {
    vehicles: vehicleReducer,
    faqs: faqSlice,
    location: locationSlice,
    popups: popupsReducer,
    snackbar: snackbarSliceReducer,
    lead: leadSlice,
  },
});
